export enum FolderModal {
  Create = "folder__create",
  Delete = "folder__delete",
  CopyToAnotherAccount = "folder__copyToAnotherAccount",
  Rename = "folder__rename",
  Share = "folder__share",
  Move = "folder__move",
}

export enum BulkModal {
  Move = "bulk__move",
  CopyToAnotherAccount = "bulk__copyToAnotherAccount",
  Delete = "bulk__delete",
}
